// extracted by mini-css-extract-plugin
export default {"currentDateContainer":"InterviewsLabel_currentDateContainer__sjczd"};